
import { BaseView } from "@/services/BaseView";
import { DataClient } from "@/services/DataClient";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class extends BaseView {
    showLanguageSelector = true;
    allowBlog = false;

    targetElevation = 0;
    targetBackgroundColor = "transparent";
    height = "64";
    iconHeight = "64";

    selectedOptionColor = "orange darken-2";
    unselectedOptionColor = "grey darken-2";

    @Prop({ required: true, type: String })
    language!: string;

    toggleSidebar() {
        this.$emit("toggleSidebar");
    }

    get isMobile() {
        return this.$vuetify.breakpoint.smAndDown;
    }

    get isHome() {
        return this.$route.name?.startsWith("home.");
    }

    get isActivities() {
        return this.$route.name?.startsWith("activities");
    }

    get isTransfers() {
        return this.$route.name?.startsWith("transfers");
    }

    languages = [
        {
            title: "Español",
            code: "es",
        },
        {
            title: "English",
            code: "en",
        },
        {
            title: "Română",
            code: "ro",
        },
    ];

    async mounted() {
        // check if blog is enabled by a query parameter
        const urlParams = new URLSearchParams(window.location.search);
        this.allowBlog = urlParams.get("blog") === "true";

        if (this.fullHeight) {
            window.removeEventListener("scroll", () => this.changeColor());
            window.addEventListener("scroll", () => this.changeColor());
        }
    }

    get fullHeight(): boolean {
        return DataClient.instance.configuration.fullScreenCarrousel;
    }

    get elevation(): number {
        if (this.$route.meta?.divider) {
            return 3;
        }

        return this.fullHeight ? this.targetElevation : 3;
    }

    get backgroundColor(): string {
        return this.fullHeight ? this.targetBackgroundColor : "white";
    }

    get languageName() {
        // get language name from code
        const language = this.languages.find((item) => item.code === this.$i18n.locale);
        if (language) {
            return language.title;
        }

        // fallback to code
        return this.$i18n.locale;
    }

    setLanguage(code: string) {
        this.$emit("languageChanged", code);
    }

    get logoClass() {
        return "logo-normal";
        //return this.targetBackgroundColor === "transparent" ? "logo-transparent" : "logo-normal";
    }

    get logoTextClass() {
        return "logo-text-normal";
        // return this.targetBackgroundColor === "transparent" ? "logo-text-transparent" : "logo-text-normal";
    }

    get buttonClass() {
        // return "indigo darken-4";
        return "#000bfc";
        //        return this.targetBackgroundColor === "transparent" ? "white" : "indigo darken-4";
    }

    get mallorca() {
        const category = DataClient.instance.getCategoryById("3bd27efd-b78f-4050-a7f1-c2526f6c5a12");
        return this.buildNavigationRoute("category", { id: category.slug });
    }

    get costaBrava() {
        const category = DataClient.instance.getCategoryById("50aea81e-ef50-451c-9105-7ef110c8de51");
        return this.buildNavigationRoute("category", { id: category.slug });
    }

    get costaDelSol() {
        const category = DataClient.instance.getCategoryById("c5273aab-bbae-4af9-850c-f6c69b1a09b4");
        return this.buildNavigationRoute("category", { id: category.slug });
    }

    get tenerife() {
        const category = DataClient.instance.getCategoryById("52f99a4d-fb7b-4704-94f8-25b05b692535");
        return this.buildNavigationRoute("category", { id: category.slug });
    }

    goHome() {
        this.$router.push(this.buildNavigationRoute("home"));
    }

    goActivities() {
        this.$router.push(this.buildNavigationRoute("activities"));
    }

    goTransfers() {
        this.$router.push(this.buildNavigationRoute("transfers"));
    }

    callPhoneNumber() {
        // open new tab with whatsapp link
        window.open("https://wa.me/34690370131", "_blank");
    }

    agentsLogin() {
        window.open("https://agents.cubodrivers.com", "_blank");
    }

    changeColor() {
        let elevation = 0;
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        if (scrollTop >= 0 && scrollTop < 1) {
            elevation = 0;
        } else if (scrollTop >= 2 && scrollTop < 66) {
            elevation = 1;
        } else if (scrollTop >= 66 && scrollTop < 100) {
            elevation = 2;
        } else if (scrollTop >= 100) {
            elevation = 3;
        }

        if (elevation > 0) {
            this.targetBackgroundColor = "white";
            this.targetElevation = elevation;
            this.height = "64";
            this.iconHeight = "64";
        } else {
            this.targetBackgroundColor = "transparent";
            this.targetElevation = 0;
            this.height = "96";
            this.iconHeight = "96";
        }
    }
}
